import { type MCPServerInfo } from '../../types';

const ZoomServer: MCPServerInfo = {
  serverId: 'ZOOM',
  name: 'Zoom (Natoma)',
  slug: 'zoom',
  description: 'Zoom MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'mcp/zoom-mcp-server:31e9c94',
    commitSha: '31e9c94',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['zoomAccountId', 'zoomClientId', 'zoomClientSecret'],
    properties: {
      zoomAccountId: {
        type: 'string',
        description: 'Zoom Account ID',
        sensitive: false
      },
      zoomClientId: {
        type: 'string',
        description: 'Zoom Client ID',
        sensitive: false
      },
      zoomClientSecret: {
        type: 'string',
        description: 'Zoom Client Secret',
        sensitive: true
      }
    }
  }
};

export default ZoomServer;
